// This is a subset of TStandardDocumentCategory
export type TPolicyDocumentCategory =
  | 'HoldOpenOwnersPolicy'
  | 'LendersPolicy'
  | 'LongFormLendersPolicy'
  | 'OwnersPolicy'
  | 'ShortFormLendersPolicy';
export const policyDocumentCategories: TPolicyDocumentCategory[] = [
  'HoldOpenOwnersPolicy',
  'LendersPolicy',
  'LongFormLendersPolicy',
  'OwnersPolicy',
  'ShortFormLendersPolicy',
];
